/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForJenkins extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForJenkins");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForJenkins.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForJenkins>): ServiceAccountCredentialsForJenkins {
        let obj = Object.assign(new ServiceAccountCredentialsForJenkins(), model);
        ServiceAccountCredentialsForJenkins.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForJenkins>): ServiceAccountCredentialsForJenkins {
        if (!model) return null;
        return ServiceAccountCredentialsForJenkins.newInstance(<ServiceAccountCredentialsForJenkins> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForJenkins) {
        if (!obj) return;

        models.ServiceAccountCredentialsForJenkins.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForJenkins): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForJenkins.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
